import { apiGatewayClient } from '@/common/apis/client';

/** Invoice price of a service (before a book exists); shared with the profile/search prefetch. */
export const factorServicePriceKey = (centerId: string, serviceId?: string, userCenterId?: string, isLogin?: boolean) => [
  'factorServicePrice',
  centerId,
  serviceId,
  userCenterId,
  isLogin,
];
export const fetchFactorServicePrice = async (centerId: string, serviceId: string, userCenterId: string) => {
  const { data } = await apiGatewayClient('/v1/service-price', {
    params: { center_id: centerId, service_id: serviceId, user_center_id: userCenterId },
  });
  return {
    totalPrice: data?.result?.payable_cost as string | undefined,
    price: data?.result?.service_price as string | undefined,
    tax: data?.result?.vat as string | undefined,
  };
};
